
String.prototype.toProperCase = function () {
  return this.replace(/\w\S*/g, function (txt) { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(); });
}


import React from "react";
import ReactDOM from "react-dom";
import { Suspense } from "react";
import MainLoader from "./components/UI/MainLoader";

// import "./assets/css//bootstrap.min.css";

const PublicApp = React.lazy(() => import("./PublicApp"));
const PrivateApp = React.lazy(() => import("./PrivateApp"));

function Root() {
  const isLoggedIn = localStorage.getItem("__user__");

  return (
    <Suspense fallback={<MainLoader />}>
      {isLoggedIn ? <PrivateApp /> : <PublicApp />}
    </Suspense>

  );
}

ReactDOM.render(<Root />, document.getElementById("root"));
